export default function ({blockIndex, exclude, brandId = '', modelId = '',  }) {
    const resultArr = [blockIndex];
    if(exclude) resultArr.push('not');
    if(Boolean(brandId)) resultArr.push(brandId);
    if(Boolean(modelId)) resultArr.push(modelId);

    return resultArr.join('-')
}
